module.exports = __webpack_public_path__ + "static/media/hayagreeva-ss.a2f8ed70.png";